// This file can be copied to app.config.js
// App.config.js is ignored by git, and can be different per system

module.exports = {
    api_url: 'https://api-crs.nibhv.nl',
    environment: 'production',
    onboarding_state: 1,
    sentry_key: 'f2203a8a7e7548038eaedc65e727173b',
    sentry_app: '145398',
    sentry_env: 'production',
    google_analytics_id: 'UA-63941095-4',
    hotjar_id: '1595437',
    walletEnabled: true,
};



// WEBPACK FOOTER //
// ../app.config.js